export default (element) => {
  const clickHandle = (e) => {
    e.preventDefault();
    if (e.target.closest('[data-video-controls]')) return;
    document.dispatchEvent(
      new CustomEvent(
        e.currentTarget.dataset.type.toLowerCase() === 'outfit'
          ? 'look-overlay:open'
          : 'quick-view:open',
        {
          detail:
            e.currentTarget.dataset.type.toLowerCase() === 'outfit'
              ? {
                  id: e.currentTarget.dataset.id,
                }
              : {
                  handle: e.currentTarget.dataset.handle,
                },
        },
      ),
    );
  };

  const init = () => {
    element
      .querySelectorAll('[data-type]')
      .forEach((el) => el.addEventListener('click', clickHandle));

      element.querySelectorAll('[data-media-container]').forEach((el) => {
        
        if (!el.querySelector('[data-component="video"]')) 
          return;
  
        const intersectionObserver = new IntersectionObserver(
          ([entry]) => {

            const elTarget = entry.target;

            const videoContainer = elTarget.querySelector(
              '[data-component="video"]',
            );

            if(!videoContainer || !videoContainer.videoComponent) {
              return;
            }
            
            if (entry.isIntersecting) {
              videoContainer.videoComponent.playVideo();
            } else {
              videoContainer.videoComponent.pauseVideo();
            }

          },
          { rootMargin: '-30%' },
        );
        intersectionObserver.observe(el);
      });
  };

  init();
};
